<script setup lang="ts">
import type { PropType } from 'vue'

const props = defineProps({
	percent: { type: Number as PropType<number | null>, required: false, default: null },
	indeterminate: { type: Boolean, required: false },
	message: { type: String, required: false, default: '' }
})
</script>

<template>
	<div>
		<span v-if="props.message" class="d-block text-caption">
			{{ props.message }}
			<template v-if="props.percent !== null"> ({{ props.percent }}%) </template>
		</span>
		<v-progress-linear
			:model-value="props.percent ?? undefined"
			:indeterminate="props.indeterminate"
			color="primary"
			height="6"
			rounded
		></v-progress-linear>
	</div>
</template>

<style lang="css" scoped></style>
